import {
  COVID_SERVICE_IDS,
  COVID_TEST_SERVICE_ID,
  RAPID_COVID_SERVICE_IDS,
} from '../../../constants/services';
import { URGENT_CARE_VALUE } from './ProviderTypes';

export interface Service {
  name: string;
  ids?: string;
  value?: string;
  providerType: string;
  icon: string;
}

export const services: Array<Service> = [
  {
    name: 'COVID test',
    ids: COVID_SERVICE_IDS.join(','),
    providerType: URGENT_CARE_VALUE,
    icon: '/images/icons/services/covid_test.svg',
  },
  {
    name: 'Rapid COVID test',
    ids: RAPID_COVID_SERVICE_IDS.join(','),
    providerType: URGENT_CARE_VALUE,
    icon: '/images/icons/services/antibody_test.svg',
  },
];
